import { QuizExperience } from 'src/pages/shared'
import { useAppContext } from '../app'

export function useGetX4FromSession(): string | null {
  const { experiment } = useAppContext()
  const x4 = experiment?.includes(QuizExperience.X4_QUIZ_DETAILS) ? 'true' : null
  return x4
}
